import { render, staticRenderFns } from "./panorama.vue?vue&type=template&id=2190680b&scoped=true&"
import script from "./panorama.vue?vue&type=script&lang=js&"
export * from "./panorama.vue?vue&type=script&lang=js&"
import style0 from "./panorama.vue?vue&type=style&index=0&id=2190680b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190680b",
  null
  
)

export default component.exports